// Constant holding the values of the 2D/3D Visibility Switch.
export const ViewModes = Object.freeze({
    initial3D: 1,
    clicked3D: 2,
    clicked2D: 3
});
